// extracted by mini-css-extract-plugin
export default {"root":"TextAreaField_root__Gv48w","label":"TextAreaField_label__65HbV","errorLabel":"TextAreaField_errorLabel__lrD2y","footerLabel":"TextAreaField_footerLabel__w9yYe"};